import React, { useEffect, useState } from "react";

import { useTranslation } from "utils";

import { Flex, Icon, Typography } from "components";

import { CMC_ROUTES } from "pages/app/crop-mix-composer/CropMixComposerOverlay";

const LOADING_MESSAGE_KEYS = ["searchingCoverCrops", "findingNutrientBindingCrops", "selectingBestMatch", "searchingSoilTypeMatch"];
const MESSAGE_INTERVAL_MS = 1500;

export const AutoMixLoadingScreen = () => {
  const { t } = useTranslation("cropMixComposer");
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % LOADING_MESSAGE_KEYS.length);
    }, MESSAGE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  return (
    <Flex vertical align="center" justify="center" gap="0.75rem" data-testid="auto-mix-loading-screen" className="width-100">
      <Icon iconName="klim/plant-ai" size="xl-light" strokeWidth={0.75} />
      <Typography variant="paragraph-m">{t(`page.${CMC_ROUTES.GOALS}.autoMixModeLoading.${LOADING_MESSAGE_KEYS[currentMessageIndex]}`)}</Typography>
    </Flex>
  );
};
